(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
(() => {
  const namespace = 'MiyakoProductGalleryDots';

  if (!window[namespace]) {
    const setActive = (dots, activeIndex) => {
      dots.forEach((dot, index) => {
        dot.setAttribute('aria-current', String(index === activeIndex));
      });
    };

    const initGallery = (gallery) => {
      if (gallery.dataset.galleryDotsReady === 'true') return;

      const scroller = gallery.querySelector('[data-product-media-list]');
      const slides = Array.from(gallery.querySelectorAll('.product__slide'));
      const dots = Array.from(gallery.querySelectorAll('[data-product-gallery-dot]'));

      if (!scroller || slides.length < 2 || slides.length !== dots.length) return;

      gallery.dataset.galleryDotsReady = 'true';
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const firstOffset = slides[0].offsetLeft;
          scroller.scrollTo({
            left: slides[index].offsetLeft - firstOffset,
            behavior: 'smooth'
          });
        });
      });

      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

        if (!visible) return;
        setActive(dots, slides.indexOf(visible.target));
      }, {
        root: scroller,
        threshold: [0.55, 0.75, 0.95]
      });

      slides.forEach((slide) => observer.observe(slide));
    };

    const init = (scope) => {
      scope.querySelectorAll('product-images.product__images--mobile-slider').forEach(initGallery);
    };

    window[namespace] = { init };
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }

  const boot = () => window[namespace].init(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
